// Crop deletion, embedding search and raw image blobs.
import { CropEmbeddingSearchResponse } from '../../../types';
import { toCdnRequestUrl } from '../../../utils/cdnUrl';
import { CropLifecycleResponse } from '../../types/crops';
import { ForgeApiError, forgeRequest } from '../forgeRequest';
import { CONTROL_EMBEDDING_API_URL, FORGE_CROPS_API_URL } from './endpoints';

export async function deleteCrops(
  token: string,
  cropIds: string[]
): Promise<CropLifecycleResponse> {
  return forgeRequest<CropLifecycleResponse>(token, FORGE_CROPS_API_URL, 'Error deleting crops', {
    method: 'DELETE',
    body: { crop_ids: cropIds },
  });
}

export async function searchEmbeddingsByCropIds(
  token: string,
  embeddingCropIds: string[]
): Promise<CropEmbeddingSearchResponse[]> {
  const params = new URLSearchParams();
  embeddingCropIds.forEach((id) => {
    params.append('embedding_crop_ids', id);
  });
  params.append('include_item_number', 'false');

  return forgeRequest<CropEmbeddingSearchResponse[]>(
    token,
    `${CONTROL_EMBEDDING_API_URL}/by-ids?${params}`,
    'Error fetching embedding crops by ids'
  );
}

/**
 * Fetches an image (e.g. a crop or product photo) as a Blob using session
 * credentials. Shared by flows that re-upload or convert existing images.
 */
export async function fetchImageBlob(url: string): Promise<Blob> {
  // CDN fetch: cookie credentials, no auth header, and no 401-logout side
  // effect — only the thrown error type is unified with the transport.
  const response = await fetch(toCdnRequestUrl(url), { credentials: 'include' });
  if (!response.ok) {
    throw new ForgeApiError(
      `Failed to fetch image: ${response.status} ${response.statusText} (${url})`,
      response.status
    );
  }
  return response.blob();
}
